export const quartiers = [
  {
    slug: "gestion-locative-paris-8",
    code: "75008",
    short: "Paris 8",
    name: "Paris 8e",
    dans: "dans le 8e arrondissement",
    du: "du 8e arrondissement",
    title: "Gestion locative Paris 8 — Loyaris",
    description:
      "Gestion locative dans le 8e arrondissement de Paris : agence Loyaris au 128 rue la Boétie, gestionnaire dédié, loyers garantis MMA. Dès 3,60 % TTC.",
    image:
      "https://images.unsplash.com/photo-1614349214089-e969a07e033b?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Notre agence est au cœur du 8e, rue la Boétie.",
    intro:
      "Le 8e arrondissement, entre Champs-Élysées, Madeleine, Monceau et Europe, est un marché locatif exigeant : immeubles haussmanniens, appartements de standing et forte demande d'une clientèle de cadres, d'expatriés et d'étudiants des grandes écoles. Avec notre siège au 128 rue la Boétie, nous gérons votre bien à quelques minutes à pied, avec un suivi digital en temps réel.",
    neighborhoods: ["Champs-Élysées", "Faubourg-du-Roule", "Madeleine", "Europe"],
    tenants: "Cadres en mobilité, expatriés, jeunes actifs et étudiants des écoles du quartier.",
    points: [
      "Visites et états des lieux assurés par un gestionnaire basé dans l'arrondissement",
      "Fixation du loyer dans le respect de l'encadrement des loyers parisien",
      "Sélection rigoureuse des dossiers locataires et garantie loyers impayés MMA",
      "Coordination des artisans et du syndic pour les immeubles haussmanniens",
    ],
  },
  {
    slug: "gestion-locative-paris-16",
    code: "75016",
    short: "Paris 16",
    name: "Paris 16e",
    dans: "dans le 16e arrondissement",
    du: "du 16e arrondissement",
    title: "Gestion locative Paris 16 — Loyaris",
    description:
      "Gestion locative dans le 16e arrondissement : Passy, Auteuil, Muette, Chaillot. Gestionnaire dédié, suivi 100 % digital, assurance loyers impayés. Dès 3,60 % TTC.",
    image:
      "https://images.unsplash.com/photo-1657129208507-7005dfc5b36a?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Passy, Auteuil, Muette : un patrimoine à gérer avec soin.",
    intro:
      "Résidentiel et familial, le 16e arrondissement concentre de grands appartements, des immeubles de standing et une demande locative stable portée par les familles et les professionnels internationaux. Ces biens de valeur méritent un suivi attentif : entretien, relation avec le syndic, sélection des locataires et revenus sécurisés.",
    neighborhoods: ["Passy", "Auteuil", "La Muette", "Chaillot"],
    tenants: "Familles, cadres dirigeants, diplomates et professionnels internationaux.",
    points: [
      "Gestion adaptée aux grandes surfaces et aux biens de standing",
      "Suivi des travaux d'entretien avec votre accord préalable",
      "Paiement des appels de fonds du syndic avec la Formule Sérénité",
      "Assurance loyers impayés MMA sans franchise ni délai de carence",
    ],
  },
  {
    slug: "gestion-locative-paris-17",
    code: "75017",
    short: "Paris 17",
    name: "Paris 17e",
    dans: "dans le 17e arrondissement",
    du: "du 17e arrondissement",
    title: "Gestion locative Paris 17 — Loyaris",
    description:
      "Gestion locative dans le 17e arrondissement : Batignolles, Ternes, Plaine-Monceau, Épinettes. Gestionnaire dédié et loyers garantis. Dès 3,60 % TTC.",
    image:
      "https://images.pexels.com/photos/30248853/pexels-photo-30248853.jpeg?auto=compress&cs=tinysrgb&w=1600",
    tagline: "Des Ternes aux Batignolles, un marché vivant et recherché.",
    intro:
      "Le 17e arrondissement allie l'élégance de la Plaine-Monceau et des Ternes au dynamisme des Batignolles et du nouveau quartier Clichy-Batignolles. Studios, deux-pièces et appartements familiaux s'y louent rapidement : à condition d'être bien positionnés en prix et irréprochables dans la gestion.",
    neighborhoods: ["Ternes", "Plaine-Monceau", "Batignolles", "Épinettes"],
    tenants: "Jeunes actifs, couples, familles et professionnels du quartier d'affaires voisin.",
    points: [
      "Mise en location rapide grâce à un loyer juste, conforme à l'encadrement",
      "Émission des quittances, encaissement et reversement chaque mois",
      "Régularisation annuelle des charges avec la Formule Sérénité",
      "Un interlocuteur unique, joignable et présent sur le terrain",
    ],
  },
  {
    slug: "gestion-locative-paris-7",
    code: "75007",
    short: "Paris 7",
    name: "Paris 7e",
    dans: "dans le 7e arrondissement",
    du: "du 7e arrondissement",
    title: "Gestion locative Paris 7 — Loyaris",
    description:
      "Gestion locative dans le 7e arrondissement : Gros-Caillou, Invalides, École-Militaire, Saint-Thomas-d'Aquin. Gestionnaire dédié et loyers garantis MMA. Dès 3,60 % TTC.",
    image:
      "https://images.unsplash.com/photo-1581262177533-1b1760b87952?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Des Invalides au Gros-Caillou, un patrimoine d'exception.",
    intro:
      "Entre la tour Eiffel, les Invalides et le faubourg Saint-Germain, le 7e arrondissement est l'un des secteurs les plus prisés de la capitale. Ministères, ambassades et grandes institutions y attirent une clientèle exigeante, en quête d'appartements de caractère. Une gestion irréprochable y est indispensable pour préserver la valeur de votre bien et fidéliser vos locataires.",
    neighborhoods: ["Gros-Caillou", "Invalides", "École-Militaire", "Saint-Thomas-d'Aquin"],
    tenants: "Diplomates, hauts fonctionnaires, cadres internationaux et familles.",
    points: [
      "Sélection rigoureuse des locataires et constitution de dossiers solides",
      "Loyer fixé dans le respect de l'encadrement des loyers parisien",
      "Suivi des travaux d'entretien avec votre accord préalable",
      "Assurance loyers impayés MMA sans franchise ni délai de carence",
    ],
  },
  {
    slug: "gestion-locative-paris-15",
    code: "75015",
    short: "Paris 15",
    name: "Paris 15e",
    dans: "dans le 15e arrondissement",
    du: "du 15e arrondissement",
    title: "Gestion locative Paris 15 — Loyaris",
    description:
      "Gestion locative dans le 15e arrondissement : Grenelle, Javel, Necker, Saint-Lambert. Gestionnaire dédié, suivi 100 % digital, loyers garantis. Dès 3,60 % TTC.",
    image:
      "https://images.unsplash.com/photo-1593474769219-fea89cf0bbef?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Le plus peuplé des arrondissements, une demande locative constante.",
    intro:
      "Premier arrondissement de Paris par sa population, le 15e offre un marché locatif dynamique et équilibré : studios recherchés par les étudiants et jeunes actifs, appartements familiaux autour de Grenelle, du Commerce ou de Convention. Bien loué au juste prix, votre logement y trouve preneur rapidement et durablement.",
    neighborhoods: ["Grenelle", "Javel", "Necker", "Saint-Lambert"],
    tenants: "Étudiants, jeunes actifs, couples et familles.",
    points: [
      "Mise en location rapide grâce à un loyer juste, conforme à l'encadrement",
      "Émission des quittances, encaissement et reversement chaque mois",
      "Régularisation annuelle des charges avec la Formule Sérénité",
      "Un gestionnaire dédié, joignable et présent sur le terrain",
    ],
  },
  {
    slug: "gestion-locative-neuilly-sur-seine",
    code: "neuilly",
    short: "Neuilly-sur-Seine",
    name: "Neuilly-sur-Seine",
    dans: "à Neuilly-sur-Seine",
    du: "à Neuilly-sur-Seine",
    noEncadrement: true,
    title: "Gestion locative Neuilly-sur-Seine — Loyaris",
    description:
      "Gestion locative à Neuilly-sur-Seine (92) : Saint-James, Bagatelle, Sablons. Gestionnaire dédié, suivi 100 % digital et assurance loyers impayés MMA. Dès 3,60 % TTC.",
    image:
      "https://images.unsplash.com/photo-1669559701664-86712b87d37c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
    tagline: "Aux portes de Paris, un marché résidentiel haut de gamme.",
    intro:
      "Entre le bois de Boulogne et la Seine, Neuilly-sur-Seine séduit par son cadre résidentiel, ses avenues arborées et sa proximité immédiate avec Paris et La Défense. Les appartements familiaux et biens de standing y sont très demandés par une clientèle de cadres et de familles : une gestion attentive permet d'en tirer le meilleur rendement.",
    neighborhoods: ["Saint-James", "Bagatelle", "Les Sablons", "Madrid"],
    tenants: "Familles, cadres de La Défense et professionnels internationaux.",
    points: [
      "Gestionnaire qui se déplace pour les visites et états des lieux",
      "Positionnement du loyer au plus juste du marché local",
      "Paiement des appels de fonds du syndic avec la Formule Sérénité",
      "Assurance loyers impayés MMA sans franchise ni délai de carence",
    ],
  },
];
